<template>
    <div class="scancoupon">
        <div class="header"></div>
        <div class="con">
            <div class="top">
                <div class="title">抽奖二维码</div>

                <img :src="detail.qrcode" />

                <div class="btn">{{detail.checkstate == 0 ? '待核销' : '已核销'}}</div>
            </div>
            

            <div class="bot">1、活动时间5月31日-6月2日10:00-21:00；<br/>
2、三大区域线上打卡累计满15个点位，即可获得1次抽奖资格，其中保利时光里B1中庭“好伙伴宠物”和绿地缤纷城1F“TREK自行车”为两个必打卡点位；<br/>
3、每个账号每天仅可参与一次抽奖，每次完成抽奖后即当天打卡记录清零，当天无法再次抽奖；<br/>
4、凭核销码到正大广场中庭“奖品兑换处”，进行抽奖；<br/>
5、本次活动最终解释权归主办方所有。</div>
        </div>
    </div>
</template>

<script>
import "./index.less";
export default {
    data() {
        return {
            activity_id: '',
            sub_aid: '',
            score: 0,
            freenum: 0,
            detail: {},
            timer: ''
        };
    },
    mounted() {
        this.activity_id = this.$route.params.acid
        this.timer = setInterval(this.init, 1000);
    },
    methods: {
        init() {
            let params = { acid: this.activity_id };
            this.$api.activity.usercheck(params).then(res => {
                if(res.status==200){
                    this.detail = res.data
                    if(this.detail.checkstate == 1)
                        clearInterval(this.timer);
                }
            });
        }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
}
</script>